import React from 'react';
import { Button, Modal } from 'react-bootstrap';

import { Grid } from '../../../common/components/Grid/Grid';
import {
  GridColumn,
  GridRecord,
} from '../../../common/components/Grid/GridDataTypes';
import { GetCriticalPointDetailItemDto } from '../../../common/spdCore/autogenerated/spdApiClient';
import { historicalView } from '../../components/Results/Results';

interface CriticalPointDetailsModalProps {
  show: boolean;
  onHide: () => void;
  items: GetCriticalPointDetailItemDto[];
}

const columns: GridColumn[] = [
  { header: 'Test', property: 'testName' },
  { header: 'Pytanie', property: 'taskNumber', noSorting: true },
  { header: 'Odpowiedź', property: 'answerCodeValue', noSorting: true },
  {
    header: 'Zdekodowana odpowiedź',
    property: 'answerValue',
    noSorting: true,
  },
  {
    header: 'Typ punktu krytycznego',
    property: 'criticalType',
    noSorting: true,
  },
];

const itemForGrid = (
  item: GetCriticalPointDetailItemDto,
  idx: number,
): GridRecord => ({
  key: String(idx),
  values: {
    testName: item.testName,
    taskNumber: (
      <>
        {item.taskNumber}
        {item.taskText && item.taskText !== item.taskNumber && (
          <div className="text-muted small">{item.taskText}</div>
        )}
      </>
    ),
    answerCodeValue: item.answerCodeValue ?? '—',
    answerValue: historicalView(
      1,
      '',
      item.answerValue ?? null,
      false,
      item.criticalType,
      item.answerValueType,
    ),
    criticalType: <strong>{item.criticalType}</strong>,
  },
});

export const CriticalPointDetailsModal: React.FC<
  CriticalPointDetailsModalProps
> = ({ show, onHide, items }) => {
  return (
    <Modal show={show} onHide={onHide} size="xl" centered>
      <Modal.Header closeButton>
        <Modal.Title>Punkty krytyczne — szczegóły</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Grid
          columns={columns}
          data={items.map(itemForGrid)}
          showFilter={false}
          withHistory={false}
        />
      </Modal.Body>
      <Modal.Footer>
        <Button variant="outline-secondary" onClick={onHide}>
          Zamknij
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
